export enum IslandType {
	// Standard = 'STANDARD',
	Asado = 'ASADO',
	Bar = 'BAR',
	Corner = 'CORNER',
	FirePit = 'FIRE_PIT',
	Grill = 'GRILL',
	Pizza = 'PIZZA',
	Smoker = 'SMOKER'
}
